module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"balance\"-in-garden-grove-california-9d476b0c828649bc1ddf2341e989c96b.png";